import { css } from "@emotion/react";

export const resetAnchorStyle = css`
  all: unset;
  cursor: pointer;
`;
